import { View } from 'react-native'
import { colors } from '@ui/colors'
import cn from '@ui/utils/cn'

import { StepStatus } from './utils'

interface Props {
  count: number
  current: number
  statuses?: StepStatus[]
}

const dotColor: Record<StepStatus, string> = {
  default: 'rgba(0,0,0,0.2)',
  success: colors.green[600],
  danger: colors.red[600],
}

export default function StepDots({ count, current, statuses }: Props) {
  return (
    <View className="flex-row items-center gap-3">
      {Array.from({ length: count }).map((_, i) => {
        const isCurrent = i === current
        const status = statuses?.[i] ?? 'default'
        const isWide = isCurrent
        return (
          <View
            key={i}
            className={cn('rounded-full', {
              'h-2 w-6': isWide,
              'h-2 w-2': !isWide,
            })}
            style={{
              backgroundColor: isCurrent
                ? status === 'default'
                  ? colors.black
                  : dotColor[status]
                : dotColor[status],
            }}
          />
        )
      })}
    </View>
  )
}
